import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { ServiceNameEnum } from '@Types/index';

import { useDashboardDaysStore } from '../../../../models/useDashboardDaysModel';
import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import DlpPolicies from './DlpPolicies';
import DlpTemplates from './DlpTemplates';
import DlpViolators from './DlpViolators';
import DlpViolatorsByDst from './DlpViolatorsByDst';
import DlpViolatorsBySrc from './DlpViolatorsBySrc';
import { DashboardPeriod } from '@Types/dashboard';
import { useExpandSection } from '../useExpandSection';

export default function Dlp() {
  const { t } = useTranslation();
  const [widgetHideConfig, setWidgetHideConfig] = useState<any>({});
  const servicesModel = useDashboardServicesStore();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'dataLossPrevention',
      period: daysModel.days.DashboardDlp as DashboardPeriod,
    });

  useEffect(() => {
    if (
      servicesModel.hasEnabledProvisionedServices &&
      !servicesModel.enabledServices.includes(ServiceNameEnum.Box)
    ) {
      setWidgetHideConfig({ dlpViolators: true });
    }
  }, [servicesModel]);

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.dlp')}
      titleBar={<TimeRangeSelector widgetId="DashboardDlp" />}
      barColor="#C9B87E"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <DlpPolicies data={data} day={daysModel.days['DashboardDlp']} />
      <DlpViolatorsBySrc data={data} day={daysModel.days['DashboardDlp']} />
      <DlpTemplates data={data} day={daysModel.days['DashboardDlp']} />
      <DlpViolatorsByDst data={data} day={daysModel.days['DashboardDlp']} />
      {widgetHideConfig['dlpViolators'] ? (
        ''
      ) : (
        <DlpViolators data={data} day={daysModel.days['DashboardDlp']} />
      )}
    </DashboardLayout>
  );
}
